import { getScribeHttpClients } from '@heidi/api/client';

/**
 * Specialty row as `/specialties` returns it. Structural so this module does
 * not import the app's `ClinicianTypeInput`.
 */
export type SpecialtyListItem = {
  id: string;
  name: string;
  localized_name?: string;
  group: {
    id: string;
    name: string;
  };
  clinical_content_group?: string;
  groups?: { name: string }[];
  requires_hcp_verification?: boolean;
};

/** @domain workspace */
export const getSpecialties = (country?: string, acceptLanguage?: string) => {
  // `Accept-Language` is the app's active UI language. It only decides when no
  // user document resolves; a stored account language wins server-side.
  const config = {
    ...(country && { params: { country } }),
    ...(acceptLanguage && { headers: { 'Accept-Language': acceptLanguage } }),
  };
  return getScribeHttpClients().scribeHttp.get<{
    specialties: SpecialtyListItem[];
    total: number;
  }>('/specialties', Object.keys(config).length > 0 ? config : undefined);
};
